<template>
    <div>
        <!-- Modal Component -->
        <b-modal v-model="openModal"
            :title="(action_id || (action && action.corrective_action_id) ? 'Edit': 'New') + ' Corrective Action'"
            size="lg"
            ok-title="Save Corrective Action"
            ok-variant="success"
            no-fade
            @hide="handleHide"
            @hidden="handleHidden"
            @ok="handleOk"
            :ok-disabled="saving"
            ref="correctiveActionModal"
            :no-close-on-backdrop="true"
            scrollable>

            <div>
                <div v-if="loading" class="text-center">
                    <i class="fa fa-circle-o-notch fa-spin"></i> Loading
                </div>
                <div v-else>
                    <div v-bind:class="{ 'form-group': true, 'has-error': errors.detail }" class="row">
                        <label class="col-lg-2 offset-lg-0 col-md-10 offset-md-1 col-12 col-form-label text-lg-right">Explain Corrective Action: <i v-if="!action.detail" class="fa fa-asterisk small text-danger"></i></label>
                        <div class="col-lg-8 offset-lg-0 col-md-10 offset-md-1 col-12">
                            <textarea :class="{ 'is-invalid': errors.detail, 'form-control': true}" v-model="action.detail" placeholder="Enter Details" style="min-height: 100px;"></textarea>
                            <span v-if="errors.detail" class="text-danger">
                                <span v-for="error in errors.detail">{{ error }}</span>
                            </span>
                        </div>
                    </div>
                    <div v-bind:class="{ 'form-group': true, 'has-error': errors.completed_detail }" class="row">
                        <label class="col-lg-2 offset-lg-0 col-md-10 offset-md-1 col-12 col-form-label text-lg-right">Completed Detail: <i v-if="!action.completed_detail && statusContext === 'Closed'" class="fa fa-asterisk small text-danger"></i></label>
                        <div class="col-lg-8 offset-lg-0 col-md-10 offset-md-1 col-12">
                            <textarea :class="{ 'is-invalid': errors.completed_detail, 'form-control': true}" v-model="action.completed_detail" placeholder="Enter Completed Details" style="min-height: 100px;"></textarea>
                            <span v-if="errors.completed_detail" class="text-danger">
                                <span v-for="error in errors.completed_detail">{{ error }}</span>
                            </span>
                        </div>
                    </div>
                    <div v-bind:class="{ 'form-group': true, 'has-error': errors.status_id }" class="row">
                        <label class="col-lg-2 offset-lg-0 col-md-10 offset-md-1 col-12 col-form-label text-lg-right">Status: <i v-if="!action.status_id" class="fa fa-asterisk small text-danger"></i></label>
                        <div class="col-lg-8 offset-lg-0 col-md-10 offset-md-1 col-12">
                            <select :class="{ 'is-invalid': errors.status_id, 'form-control': true}" v-model="action.status_id">
                                <option :value="null">-- Select a Status --</option>
                                <option v-for="(value, key) in statuses" v-bind:value="value.status_id">
                                    {{ value.status_name }}
                                </option>
                            </select>
                            <span v-if="errors.status_id" class="text-danger">
                                <span v-for="error in errors.status_id">{{ error }}</span>
                            </span>
                        </div>
                    </div>
                    <div v-bind:class="{ 'form-group': true, 'has-error': errors.corrective_source_id }" class="row" v-if="Object.keys(sources).length > 0">
                        <label class="col-lg-2 offset-lg-0 col-md-10 offset-md-1 col-12 col-form-label text-lg-right">Source:</label>
                        <div class="col-lg-8 offset-lg-0 col-md-10 offset-md-1 col-12">
                            <select :class="{ 'is-invalid': errors.corrective_source_id, 'form-control': true}" v-model="action.corrective_source_id">
                                <option :value="null">-- Select a Source --</option>
                                <option v-for="(value, key) in sources" v-bind:value="key">
                                    {{ value }}
                                </option>
                            </select>
                            <span v-if="errors.corrective_source_id" class="text-danger">
                                <span v-for="error in errors.corrective_source_id">{{ error }}</span>
                            </span>
                        </div>
                    </div>

                    <action-assignees ref="otherAssignees" v-model="action" :errors="errors"></action-assignees>

                    <div v-bind:class="{ 'form-group': true, 'has-error': errors.location }" class="row">
                        <label class="col-lg-2 offset-lg-0 col-md-10 offset-md-1 col-12 col-form-label text-lg-right">Location: <i v-if="!action.location" class="fa fa-asterisk small text-danger"></i></label>
                        <div class="col-lg-8 offset-lg-0 col-md-10 offset-md-1 col-12">
                            <input type="text" name="location" v-model="action.location" :class="{ 'is-invalid': errors.location, 'form-control': true}" placeholder="Corrective Action Location" />
                            <span v-if="errors.location" class="text-danger">
                                <span v-for="error in errors.location">{{ error }}</span>
                            </span>
                        </div>
                    </div>
                    <div v-bind:class="{ 'form-group': true, 'has-error': errors.due_date }" class="row">
                        <label class="col-lg-2 offset-lg-0 col-md-10 offset-md-1 col-12 col-form-label text-lg-right">Due Date: <i v-if="!action.due_date && (statusContext === 'Open' || statusContext == 'InProgress')" class="fa fa-asterisk small text-danger"></i></label>
                        <div class="col-lg-8 offset-lg-0 col-md-10 offset-md-1 col-12">
                            <b-form-input type="date" v-model="action.due_date" placeholder="Enter Due Date" class="form-control" />

                            <span v-if="errors.due_date" class="text-danger">
                                <span v-for="error in errors.due_date">{{ error }}</span>
                            </span>
                        </div>
                    </div>
                    <div v-bind:class="{ 'form-group': true}" class="row">
                        <label class="col-lg-2 offset-lg-0 col-md-10 offset-md-1 col-12 col-form-label text-lg-right">Is Subcontractor:</label>
                        <div class="col-lg-8 offset-lg-0 col-md-10 offset-md-1 col-12">
                            <b-form-checkbox v-model="action.is_subcontractor" :value="1" :unchecked-value="0" plain />
                        </div>
                    </div>

                    <div v-if="action.is_subcontractor == 1">
                        <div class="form-group row">
                            <label :class="{'col-lg-2 offset-lg-0 col-md-10 offset-md-1 col-12 col-form-label text-lg-right': true, 'text-danger': errors.subcontractor}">Subcontractor Name:</label>
                            <div class="col-lg-8 offset-lg-0 col-md-10 offset-md-1 col-12">

                                <b-form-input type="text" :class="{ 'is-invalid': errors.subcontractor}" v-model="action.subcontractor" placeholder="Enter Subcontractor" />

                                <div class="text-info small">This is a free text field to enter the Subcontractor name. Any value is accepted.</div>

                                <span v-if="errors.subcontractor" class="text-danger">
                                    <span v-for="error in errors.subcontractor">{{ error }}</span>
                                </span>
                            </div>
                        </div>
                        <div class="form-group row">
                            <label :class="{'col-lg-2 offset-lg-0 col-md-10 offset-md-1 col-12 col-form-label text-lg-right': true, 'text-danger': errors.subcontractor_id}">Subcontractor Record:</label>
                            <div class="col-lg-8 offset-lg-0 col-md-10 offset-md-1 col-12">

                                <subcontractor-select :selectedValues="SubcontractorValues" @vselected="onSubSelectUpdate" :hasError="errors.subcontractor_id ? true : false"></subcontractor-select>

                                <div class="text-info small">This field links to your list of subcontractors in MeritEHS. Use this to associate and view corrective actions on the Subcontractor record.</div>

                                <span v-if="errors.subcontractor_id" class="text-danger">
                                    <span v-for="error in errors.subcontractor_id">{{ error }}</span>
                                </span>
                            </div>
                        </div>
                    </div>


                    <hr />

                    <div class="mt-3" v-if="enableFileUploads">
                        <div class="row mb-2">
                            <label class="col-lg-2 offset-lg-0 col-md-10 offset-md-1 col-12 col-form-label text-lg-right">Add Files:</label>
                            <div class="col-lg-8 offset-lg-0 col-md-10 offset-md-1 col-12">
                                <b-form-file plain multiple @change="generatePreviews"></b-form-file>
                            </div>
                        </div>

                        <div class="row mb-1" v-for="(file, i) in newFiles">
                            <div class="col-lg-2 offset-lg-0 col-md-10 offset-md-1 col-12 col-form-label text-lg-right text-muted">
                                <img :id="'image-'+file.lastModified" :ref="'image-'+file.lastModified" :src="previews[i]" class="img-fluid" />
                            </div>
                            <div class="col-lg-8 offset-lg-0 col-md-10 offset-md-1 col-12">
                                <div class="">{{ file.name }}</div>
                                <b-form-textarea v-model="file.description" placeholder="Enter File/Photo Note or Caption" rows="2" />
                            </div>
                        </div>
                        <hr>
                    </div>

                    <file-list :files="action.files ? action.files : []" />
                </div>
            </div>

        </b-modal>
    </div>
</template>

<script>
    export default {
        props: {
            asset_id: {
                type: Number,
                default: null,
            },
            asset_type: {
                type: String,
                default: ''
            },
            corrective_action_id: {
                type: Number,
                default: null
            },
            initial_action: {
                type: Object,
                default: null
            },
            ajaxMode: {
                type: Boolean,
                default: true
            },
            enableFileUploads: {
                type: Boolean,
                required: false,
                default: true,
            },
        },

        data() {
            return {
                openModal: false,
                loading: true,
                saving: false,
                errors: {},
                action_id: null,
                element: {},
                action: {},
                sources: {},
                statuses: {},
                newFiles: [],
                previews: [],
            }
        },

        watch: {
            'action.subcontractor'(newVal, oldVal){
                //Check for value
                if(newVal !== '' && newVal !== null)
                {
                    this.action.is_subcontractor = 1;
                }
            },

            'action.subcontractor_id'(newVal, oldVal){
                //Check for value
                if(newVal !== '' && newVal !== null)
                {
                    this.action.is_subcontractor = 1;
                }
            },
        },

        computed: {
            //Status Option Input
            statusOptions(){
                let options = {};

                //Loop
                for(var status in this.statuses)
                {
                    options[status.status_id] = status.status_name;
                }

                //Send it
                return options;
            },

            statusContext() {
                if (!this.action.status_id)
                {
                    return null;
                }

                return this.statuses[this.action.status_id].status_context;
            },

            SubcontractorValues(){
                //check for null
                if(!this.action || !this.action.subcontractor_id || this.action.subcontractor_id == null)
                {
                    //Send it
                    return null;
                }

                //Send it
                return {subcontractor_id: this.action.subcontractor_id, subcontractor_name: this.action.subcontractor_name};
            },
        },

        methods: {

            handleHide(bvEvt){
                //debugging
                if(this.$root.debug)
                {
                    //console.log('Hiding Modal');
                }
            },

            handleHidden(bvEvt){
                //We need to let the parent know that the hidden event was called.
                //For inspections, this could mean the user did not add the correct action,
                //which might be we need to revert the Compliance Status selection if the
                //form requires one for non-compliant items
                this.$emit('actionSaved', this.action);

                //Reset the values
                this.action = {};
                this.action_id = null;
                this.errors = {};
                this.newFiles = [];
                this.previews = [];
                this.showOtherUsers = false;
            },

            handleOk(bvEvt) {

               //Stops the modal from closing
               bvEvt.preventDefault();

               //Show loading?

               //Do it
               this.saveAction();
            },

            hideModal() {
                //Hide it
                this.$refs.correctiveActionModal.hide();
            },

            setActionId(action_id) {
                //this.$refs.correctiveActionForm.setActionId(action_id);
                this.action_id = action_id;
            },

            setElement(element) {
                //Set the Element
                this.element = JSON.parse(JSON.stringify(element));
            },

            setAction(action) {
                this.action = action;
            },

            showModal(){
                //Show it
                this.openModal = true;
            },

            //Get the Various Resources We Need to Edit a Corrective Action
            getErrorClass(attribute) {
                return {
                    'form-group has-error': this.errors[attribute],
                    'form-group': !this.errors[attribute],
                }
            },

            setActionId(action_id) {
                this.action_id = action_id;
                this.action = null;
                this.getAction();
            },

            setAction(action) {
                this.loading = true;
                this.action = action;
                this.action_id = null;
                if (this.action.status_id === undefined)
                    this.$set(this.action, 'status_id', null);
                if (this.action.corrective_source_id === undefined)
                    this.$set(this.action, 'corrective_source_id', null);
                if (this.action.assignee_id === undefined)
                    this.$set(this.action, 'assignee_id', null);
                setTimeout(() => this.loading = false, 1);
            },

            getResources() {
                //Get the data
                this.$http
                    .get('corrective-actions/form-inputs')
                    .then(response => {
                        //Set the Data
                        this.statuses = response.data.statuses;
                        this.sources = response.data.actionSources;
                    });
            },

            getAction() {
                //Get the data
                this.loading = true;
                this.$http
                    .get('corrective-actions/edit'+(this.action_id ? `/${this.action_id}` : ''))
                    .then(response => {
                        //Set all the data
                        if (!this.action)
                        {
                            this.action = response.data.action;
                        }

                        //SEt the Data
                        this.statuses = response.data.statuses;
                        this.sources = response.data.actionSources;

                        //Fire the Helper
                        this.$emit('actionRetrieved', this.action);

                    })
                    .then(() => {
                        //Set loading
                        this.loading = false;
                    });
            },

            saveAction() {
                //Show loading
                this.saving = true;

                //Reset the errors
                this.errors = {};

                //Setup the Playloda
                let temp_action = this.action;

                //Set all the values
                temp_action.asset_id = this.asset_id
                temp_action.asset_type = this.asset_type;
                temp_action.new_files = this.newFiles;
                temp_action.validate_only = true;

                //Send it
                this.$http
                .postWithFiles('corrective-actions/edit'+(this.action_id ? `/${this.action_id}` : ''), temp_action, this.newFiles)
                .then(response => {
                    //Alert the user?
                    this.$toastr.success('Corrective Action Saved');

                    //Set the Action
                    //this.action = response.data;
                    this.action = temp_action;

                    //Emit the Data - The hide() function will emit the action now, always
                    //this.$emit('actionSaved', response.data);

                    //Hide it
                    this.hideModal();
                })
                .catch(error => {
                    //Check for error
                    if(error.response && error.response.status === 422)
                    {
                        //Display validation errors
                        this.errors = error.response.data
                    }
                    else
                    {
                        console.log(error);
                    }
                })
                .then(() => {
                    //Show loading
                    this.saving = false;
                });
            },

            onSubSelectUpdate(sub) {
                //Check for null
                if(sub == null)
                {
                    //Clear the value
                    this.action.subcontractor_id = '';

                    //Stop Here
                    return;
                }

                //Send the value
                this.action.subcontractor_id = sub.subcontractor_id;
            },

            generatePreviews(e) {
                //Setup
                let vm = this;

                //Setup
                var files = e.target.files;

                //Reach Eacm
                for (let i = 0; i < files.length; i++)
                {
                    //Push onto the stack
                    this.newFiles.push(files[i]);

                    //Instantiate the Reader
                    let reader = new FileReader();

                    //Seutp the Load Handler
                    reader.onload = (e) => {
                        //Set the Source
                        this.$refs['image-'+files[i].lastModified].src = reader.result;

                        //Push to previews
                        this.previews.push(reader.result);

                        //Debugging
                        //console.log(this.$refs['image-'+i].src);
                    };

                    //Read the Data
                    reader.readAsDataURL(files[i]);
                }
            },

        },

        mounted() {
            //Set the height
            //this.$refs.correctiveActionModal.$refs.body.style['max-height'] = window.innerHeight * 0.75 + 'px';

            //Get the resources
            this.getResources();
            // this.action_id = this.corrective_action_id;
            // this.action = this.initial_action;

            // if (this.action)
            // {
            //     this.action_id = null;
            //     this.loading = false;
            // }
            // if (this.action_id || (Object.keys(this.sources).length === 0 && Object.keys(this.statuses).length === 0))
            // {
            //     this.getAction();
            // }
        }
    }
</script>